import * as amplitude from '@amplitude/analytics-browser';
import { removeLocalStorage, setLocalStorage } from 'libs/utils/logic/ui/systemLogic';
import { useCallback } from 'react';
import { ActionType, StateActions } from 'session/state/actions';
import { IGlobalState } from 'session/state/state';
import { LOCAL_STORAGE_AUTH_HEADER_KEY } from 'static/config/coreConfig';

declare const window;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useUserReducer = () => {
    return useCallback((state: IGlobalState, action: StateActions): IGlobalState | null => {
        switch (action.type) {
            case ActionType.SetLoggedUser:
                if (action.payload.user && action.payload.tokenType && action.payload.accessToken) {
                    const authValue = `${action.payload.tokenType} ${action.payload.accessToken}`;
                    amplitude.setUserId(action.payload.user.userId);
                    window.clarity?.('identify', action.payload.user.userId);

                    setLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY, authValue);
                } else if (!action.payload.user) {
                    removeLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);
                    try {
                        if (window.FB) {
                            window.FB.logout();
                        }
                        if (window.webkit) {
                            window.webkit.messageHandlers.logoutHandler.postMessage('logout');
                        }
                        amplitude.setUserId(undefined);
                    } catch {
                        console.log('Handled error');
                    }
                }
                return {
                    ...state,
                    loggedUser: action.payload.user,
                    loggedUserChecked: true
                };
            case ActionType.SetUserChecked:
                return {
                    ...state,
                    loggedUserChecked: action.payload.checked
                };
            case ActionType.SetDbLikelyCrashed:
                return {
                    ...state,
                    dbLikelyCrashed: action.payload.dbLikelyCrashed
                };
            default:
                return null;
        }
    }, []);
};
